<template lang="pug">
	.persistent-job-detail
		Loader(v-if="isLoading", :fullscreen="true")
		.flex-col.space-medium(v-if="job")
			.flex-row.space-large
				.flex-col.space-medium.flex-1
					.flex-col 
						.font-small.upper.grey {{ $tCaption('Name') }}
						span {{ job.Name }}
					.flex-col 
						.font-small.upper.grey {{ $tCaption('Code') }}
						span {{ job.Code }}
					.flex-col 
						.font-small.upper.grey {{ $tCaption('Created') }}
						span {{ $moment(job.Created).format('LLL') }}
				.flex-col.space-medium.flex-1
					.flex-col 
						.font-small.upper.grey {{ $tCaption('Status') }}
						span {{ status }}
					.flex-col 
						.font-small.upper.grey {{ $tCaption('Status changed at') }}
						span {{ $moment(job.StatusChangedAt).format('LLL') }}
				.flex-col.space-medium.flex-2
					.flex-col 
						.font-small.upper.grey {{ $tCaption('Target object type') }}
						span {{ targetObjectType }}
					.flex-col 
						.font-small.upper.grey {{ $tCaption('Target object id') }}
						.flex-row.space.align-center
							span {{ job.TargetObjectOid }}
							DxButton(v-if="supportOpenObject", @click="openTarget", :hint="$tCaption('Open target')", icon="find")
					.flex-col(v-if="job.ResultCreativeId")
						.font-small.upper.grey {{ $tCaption('Result creative') }}
						.flex-row.space.align-center
							span {{ job.ResultCreativeId }}
							DxButton(@click="openResultCreative", :hint="$tCaption('Open result creative')", icon="find")
			.flex-col(v-if="job.ResultError")
				.font-small.upper.grey {{ $tCaption('Result error') }}
				span {{ job.ResultError }}
			.flex-col(v-if="statusData")
				.font-small.upper.grey {{ $tCaption('Status data') }}
				JsonViewer(:value="statusData")
			.flex-col
				.font-small.upper.grey {{ $tCaption('Result JSON') }}
				JsonViewer(:value="resultJson")
</template>

<script>
	import Loader from 'app-core/Loader.vue';	
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTabPanel from 'devextreme-vue/tab-panel';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import { 
		PERSISTENT_SCHEDULE_JOB_STATUS
	} from 'app-core/constants';
	import JsonViewer from 'vue-json-viewer';

	export default {
		translationCategory: 'persistent-job.Detail',
		name: 'persistent-job-detail',
		components: {
			Loader, DxButton, DxTextBox, DxTabPanel, DxSelectBox, DxDateBox, JsonViewer
		},
		props: ['id', 'jobData'],
		data() {
			const jobStatuses = PERSISTENT_SCHEDULE_JOB_STATUS.toLocale('name', this);
			return {				
				isLoading: 0,
				job: this.jobData,
				jobStatuses
			};
		},
		created() {
			
		},
		computed: {
			objectTypes() {
				return Object.keys(this.$Data.objectTypes).map(f => ({ name: f, id: this.$Data.objectTypes[f] }));
			},
			targetObjectType() {
				return this.objectTypes.find(f => f.id === this.job.TargetObjectType)?.name;
			},
			supportOpenObject() {
				return ['Creative', 'CreativeTemplate'].includes(this.targetObjectType);
			},
			status() {
				return this.jobStatuses.find(f => f.id === this.job.Status)?.name;
			},
			resultJson() {
				try {
					return JSON.parse(this.job.ResultJson);
				} catch {
					return null;
				}
			},
			statusData() {
				try {
					return JSON.parse(this.job.StatusData);
				} catch {
					return this.job.StatusData;
				}
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.persistentJobDetail = this;
			if (!this.jobData) {
				this.loadData();
			}
		},		
		methods: {			
			async loadData() {
				this.isLoading++;
				try {
					this.isLoading++;
					this.job = ((await this.$Data.getExternalApi('PersistentJobEntity/List', `page=1&filterCriteria=['Oid', '=', '${this.id}']`, 1).finally(() => {
						this.isLoading--;
					}))?.Results || [])[0];
				} finally {
					this.$nextTick(() => this.isLoading--);
				}
			},
			openTarget() {
				switch(this.targetObjectType) {
					case 'Creative': {
						const routeData = this.$router.resolve({ path: `/creative/Detail/${this.job.TargetObjectOid}` });
						window.open(routeData.href, '_blank');
					}
				}
			},
			openResultCreative() {
				switch(this.targetObjectType) {
					case 'Creative': {
						const routeData = this.$router.resolve({ path: `/creative/Detail/${this.job.ResultCreativeId}` });
						window.open(routeData.href, '_blank');
					}
				}
			},
		}
	};
</script>

<style lang='scss'>
	.persistent-job-detail {
		.jv-container .jv-code {
			padding: 4px !important;
		}
	}
</style>
